'use strict';

import React from 'react';

export const NetworkContext = React.createContext(true);



// WEBPACK FOOTER //
// ./src/helpers/NetworkContext.js